var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPleatedSkirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.965,
    height: 56,
    viewBox: "0 0 57.965 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.488 8.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.336,
    height: 3.752,
    transform: "translate(12.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.125,8.875,40.691,36.161a12.292,12.292,0,0,1-8.078,3.411",
    transform: "translate(7.777 -5.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.691,8.875,3.125,36.161A12.292,12.292,0,0,0,11.2,39.571",
    transform: "translate(-3.125 -5.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.6,12.625l3.59,28.138s-1.8.853-6.283.853-6.283-.853-6.283-.853l3.59-28.138",
    transform: "translate(2.326 -3.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.068,12.625l7.18,25.58s-2.872,2.558-9.873,2.558",
    transform: "translate(6.142 -3.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.93,12.625,8.75,38.205s2.872,2.558,9.873,2.558",
    transform: "translate(-0.672 -3.757)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 57.965,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleatedSkirt);
export default __webpack_public_path__ + "static/media/PleatedSkirt.82e89057d4a711eef09d1195289a2829.svg";
export { ForwardRef as ReactComponent };